import securedAxios from '~/javascript/utils/axios'

const axios = securedAxios()

export function runAioAnalysis(pageId) {
  return axios.post(`/ajax/website_pages/${pageId}/run_aio_analysis`)
}

export function getAioOptimization(pageId) {
  return axios.get(`/ajax/website_pages/${pageId}/aio_optimization`)
}

export function runAioOptimization(pageId) {
  return axios.post(`/ajax/website_pages/${pageId}/run_aio_optimization`)
}

export function approveAioOptimization(pageId) {
  return axios.post(`/ajax/website_pages/${pageId}/approve_aio_optimization`)
}
